const navbarLink = [
  {
    navId: "#about",
    title: "About",
  },
  {
    navId: "#experience",
    title: "Experience",
  },
  {
    navId: "#skills",
    title: "Skills",
  },
  {
    navId: "#projects",
    title: "Projects",
  },
  {
    navId: "#certificates",
    title: "Certificates",
  },
];

const getNavbarLinkData = () => {
  return navbarLink;
};

export default getNavbarLinkData;
